import {
  ACCOUNT_USER_TYPE_ADMIN, ACCOUNT_USER_TYPE_CONSULTANT, ACCOUNT_USER_TYPE_INVESTOR,
  ACCOUNT_USER_TYPE_EXTERNAL_LIMITED_PARTNER, ACCOUNT_USER_TYPE_LIMITED_PARTNER, ACCOUNT_USER_TYPE_REGULAR,
  ACCOUNT_USER_TYPE_SYSTEM_ADMIN,
} from './account-user-types';

export const ACCOUNT_USER_TYPE_LIST_PORTFOLIO_LIMITED: string[] = [
  ACCOUNT_USER_TYPE_REGULAR,
  ACCOUNT_USER_TYPE_CONSULTANT,
  ACCOUNT_USER_TYPE_LIMITED_PARTNER,
  ACCOUNT_USER_TYPE_EXTERNAL_LIMITED_PARTNER,
];

export const ACCOUNT_USER_TYPE_LIST_DEAL_LIMITED: string[] = [
  ACCOUNT_USER_TYPE_CONSULTANT,
  ACCOUNT_USER_TYPE_LIMITED_PARTNER,
  ACCOUNT_USER_TYPE_INVESTOR,
  ACCOUNT_USER_TYPE_EXTERNAL_LIMITED_PARTNER,
];

export const ACCOUNT_USER_TYPE_LIST_ADMIN: string[] = [
  ACCOUNT_USER_TYPE_SYSTEM_ADMIN,
  ACCOUNT_USER_TYPE_ADMIN,
];

export const ACCOUNT_USER_TYPE_LIST_TRUSTED: string[] = [
  ACCOUNT_USER_TYPE_SYSTEM_ADMIN,
  ACCOUNT_USER_TYPE_ADMIN,
  ACCOUNT_USER_TYPE_REGULAR,
];
